import PersonalDataset from "datasets/types/interfaces/personal-dataset";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

// GET /v1/users/me/dataset is get-or-create on the backend, so any mount of this
// hook provisions the caller's personal (scratch) dataset the first time it's called.
const usePersonalDataset = () =>
  useFetcher<PersonalDataset>(`${VITE_CATALOG_API}/v1/users/me/dataset`);

export default usePersonalDataset;
